// extracted by mini-css-extract-plugin
export var section = "events-module--section--gaNJM";
export var subtitle = "events-module--subtitle--3BZ4p";